export const black = '#101112';
export const white = '#fff';
export const gray = {
    title: 'Gray',
    darkest: black,
    mid: '#8690A0',
    lightest: white,
    midPoint: 500,
};
export const red = {
    title: 'Red',
    darkest: black,
    mid: '#F03E2F',
    lightest: white,
    midPoint: 500,
};
export const orange = {
    title: 'Orange',
    darkest: black,
    mid: '#FB7D24',
    lightest: white,
    midPoint: 450,
};
export const yellow = {
    title: 'Yellow',
    darkest: black,
    mid: '#FBD024',
    lightest: white,
    midPoint: 300,
};
export const green = {
    title: 'Green',
    darkest: black,
    mid: '#43D675',
    lightest: white,
    midPoint: 400,
};
export const cyan = {
    title: 'Cyan',
    darkest: black,
    mid: '#22DAF4',
    lightest: white,
    midPoint: 400,
};
export const blue = {
    title: 'Blue',
    darkest: black,
    mid: '#2276FC',
    lightest: white,
    midPoint: 500,
};
export const purple = {
    title: 'Purple',
    darkest: black,
    mid: '#C123FC',
    lightest: white,
    midPoint: 500,
};
export const magenta = {
    title: 'Magenta',
    darkest: black,
    mid: '#E5389E',
    lightest: white,
    midPoint: 500,
};
//# sourceMappingURL=config.js.map